import type { SVGProps } from 'react'
const SvgSyMap = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path fillOpacity={0.24} d="m4.5 7.5 4-2v10l-3 1.5h-1zm15 8-4 2v-10l3-1.5h1z" />
		<path d="M8.807 5.066a.96.96 0 0 0-.688.065L4.525 6.928a.95.95 0 0 0-.525.85v8.993c0 .686.762 1.157 1.375.85l3.174-1.586 6.646 1.899a.95.95 0 0 0 .686-.065l3.594-1.797a.95.95 0 0 0 .525-.85V6.23c0-.686-.762-1.157-1.375-.85l-3.174 1.586zm-.258.97 6.646 1.898a.95.95 0 0 0 .686-.065L19 6.31v8.882l-3.549 1.774-6.646-1.899a.95.95 0 0 0-.686.065L5 16.69V7.81z" />
		<path d="M15 7.5v10h1v-10zm-7-2v10h1v-10z" />
	</svg>
)
export default SvgSyMap
